import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import {toast} from 'react-toastify'
import MasterServices from '../../../../../services/master'
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
}

const Forms: React.FC<Props> = ({toggle, getData, editFormValue}) => {
  const [submit, setSubmit] = useState(false)
  const [languages, setLanguages] = useState<any>([])
  const [bidangKeilmuan, setBidangKeilmuan] = useState<any>([])
  const [document, setDocument] = useState<any>(null)
  const [formValue, setFormValue] = useState<any>({
    aplikasi: 'Talenta',
  })
  const [keywordKey, setKeywordKey] = useState<any>([])
  const [selectedKeywordKey, setSelectedKeywordKey] = useState<any>([])
  const [errors, setErrors] = useState<any>([])

  useEffect(() => {
    getLanguage('')
    getBidangKeilmuan('')
  }, [])

  useEffect(() => {
    setFormValue(editFormValue)
    setSelectedKeywordKey(editFormValue?.kata_kunci)
  }, [editFormValue])

  const onChange = (e: any) => {
    const {name, value} = e.target
    if (name === 'Dokumen') {
      setDocument(e.target.files[0])
      return
    }

    if (name === 'kata_kunci') {
      let keywordKeys: any = []
      value?.map((item: any) => {
        keywordKeys.push(item?.value)
      })

      setKeywordKey(keywordKeys)
      setSelectedKeywordKey(value)
      return
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any) => {
    const name = input

    switch (name) {
      case 'BidangKeilmuanId':
        getBidangKeilmuan(row)
        break
      case 'BahasaId':
        getLanguage(row)
        break
    }
  }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()

    const formData = new FormData(e.target)
    let formProps: any = Object.fromEntries(formData)

    formProps = {
      ...formProps,
      industries: parseInt(formProps.industries) || formProps.industries,
      bahasaId: formValue?.BahasaId?.Id ?? formValue.BahasaId,
      BidangKeilmuanId:
        formValue?.BidangKeilmuanId?.id_bidang_keilmuan ?? formValue.BidangKeilmuanId,
      Dokumen: document,
      aplikasi: 'Talenta',
      kata_kunci: JSON.stringify(keywordKey),
    }

    setSubmit(true)

    await MasterServices.storeThesis(formProps)
      .then((response) => {
        toast.success('Berhasil simpan data')
        toggle()
        getData()
        setSubmit(false)
      })
      .catch((error) => {
        setSubmit(false)
        setErrors(error?.error)
      })
  }

  const getLanguage = async (q: any) => {
    try {
      let data = await MasterServices.getThesisLanguage()
      setLanguages(data)
    } catch (error) {
    }
  }

  const getBidangKeilmuan = async (q: any) => {
    try {
      let data = await MasterServices.getThesisBidangKeilmuan({q, limit: 1000})
      setBidangKeilmuan(data)
    } catch (error) {
    }
  }

  const defaultLanguage = (data: any, dataKey: any, dataForm: any) => {
    let selectedDefault = data?.filter(
      (option: {[x: string]: any}) => option[dataKey] == formValue[dataForm]
    )

    let defaultValue =
      typeof formValue[dataForm] === 'object' ? formValue[dataForm] : selectedDefault

    return defaultValue
  }

  const selectedLanguage = (data: any, dataKey: any, dataForm: any) => {
    let selectedValue = data?.filter(
      (option: {[x: string]: any}) => option[dataKey] === formValue[dataForm]
    )

    return selectedValue
  }
  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Judul</Form.Label>
              <Form.Control
                type='text'
                name={'JudulTugasAkhir'}
                value={formValue?.JudulTugasAkhir}
                onChange={onChange}
              />
              {errors?.JudulTugasAkhir ? (
                <p className='text-danger'>{errors?.JudulTugasAkhir}</p>
              ) : null}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Abstrak</Form.Label>
              <Form.Control
                name='Abstrak'
                as='textarea'
                value={formValue?.Abstrak}
                rows={3}
                onChange={onChange}
              />
              {errors?.Abstrak ? <p className='text-danger'>{errors?.Abstrak}</p> : null}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Bahasa</Form.Label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                })}
                name={'BahasaId'}
                options={languages}
                value={
                  selectedLanguage(languages, 'Id', 'BahasaId')?.length > 0
                    ? selectedLanguage(languages, 'Id', 'BahasaId')
                    : defaultLanguage(languages, 'Id', 'BahasaId')
                }
                className='basic-multi-select'
                classNamePrefix='select'
                placeholder={`Pilih Bahasa`}
                getOptionLabel={(opt: any) => opt?.Bahasa}
                getOptionValue={(opt: any) => opt?.Id}
                onInputChange={(row) => {
                  if (typeof onSelect === 'function') {
                    onSelect('BahasaId', row)
                  }
                }}
                onChange={(row) => {
                  onChange({
                    target: {
                      name: 'BahasaId',
                      value: row,
                    },
                  })
                }}
              />
              {errors?.BahasaId ? <p className='text-danger'>{errors?.BahasaId}</p> : null}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Bidang Keilmuan</Form.Label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                })}
                name={'BidangKeilmuanId'}
                options={bidangKeilmuan}
                value={
                  selectedLanguage(bidangKeilmuan, 'id_bidang_keilmuan', 'BidangKeilmuanId')
                    ?.length > 0
                    ? selectedLanguage(bidangKeilmuan, 'id_bidang_keilmuan', 'BidangKeilmuanId')
                    : defaultLanguage(bidangKeilmuan, 'id_bidang_keilmuan', 'BidangKeilmuanId')
                }
                className='basic-multi-select'
                classNamePrefix='select'
                placeholder={`Pilih Bidang Keilmuan`}
                getOptionLabel={(opt: any) => opt?.bidang_keilmuan}
                getOptionValue={(opt: any) => opt?.id_bidang_keilmuan}
                onInputChange={(row) => {
                  if (typeof onSelect === 'function') {
                    onSelect('BidangKeilmuanId', row)
                  }
                }}
                onChange={(row) => {
                  onChange({
                    target: {
                      name: 'BidangKeilmuanId',
                      value: row,
                    },
                  })
                }}
              />
              {errors?.BidangKeilmuanId ? (
                <p className='text-danger'>{errors?.BidangKeilmuanId}</p>
              ) : null}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Kata Kunci</Form.Label>
              <CreatableSelect
                isClearable
                isMulti={true}
                placeholder='Pilih Kata Kunci'
                name='kata_kunci'
                value={selectedKeywordKey}
                // options={options}
                onChange={(row) => {
                  onChange({
                    target: {
                      name: 'kata_kunci',
                      value: row,
                    },
                  })
                }}
                onInputChange={(row) => {
                  if (typeof onSelect === 'function') {
                    onSelect('kata_kunci', row)
                  }
                }}
              />
              {errors?.kata_kunci ? <p className='text-danger'>{errors?.kata_kunci}</p> : null}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Author</Form.Label>
              <Form.Control
                type='text'
                name={'Author'}
                value={formValue?.Author}
                onChange={onChange}
              />
              {errors?.Author ? <p className='text-danger'>{errors?.Author}</p> : null}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Tahun Publish</Form.Label>
              <Form.Control
                type='number'
                name={'TahunPublish'}
                value={formValue?.TahunPublish}
                onChange={onChange}
              />
              {errors?.TahunPublish ? <p className='text-danger'>{errors?.TahunPublish}</p> : null}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className={'mb-6'}>
              <Form.Label>Negara Penerbit</Form.Label>
              <Form.Control
                type='text'
                name={'publish_country'}
                value={formValue?.publish_country}
                onChange={onChange}
              />
              {errors?.publish_country ? (
                <p className='text-danger'>{errors?.publish_country}</p>
              ) : null}
            </Form.Group>
          </Col>

          <Col md={12} className={'mb-6'}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='Dokumen' onChange={onChange} />
              </Col>
              {formValue?.Dokumen && formValue?.Dokumen ? (
                <Col md={12}>
                  <a href={formValue?.Dokumen} target='_blank'>
                    {formValue?.Dokumen}
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
            {errors?.Dokumen ? <p className='text-danger'>{errors?.Dokumen}</p> : null}
          </Col>
        </Row>

        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>

          {!editFormValue?.JenisTugasAkhirId ? (
            <Button className='btn btn-primary btn-sm' type='submit' disabled={submit}>
              {submit ? 'Loading' : 'Simpan'}
            </Button>
          ) : null}
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
